import React from 'react';

import Icon from '../Icon';

const LoginSvg = (props: any) => (
  <Icon {...props}>
    <path d="M111.133 39.904l-8.185-3.452-38.522-16.24-6.3-2.664L28.366 5 5.105 39.904 4 41.552l.626 1.74 26.167 72.434 27.333-24.5 3.678-3.285 42.1-37.741 7.703-6.907.63-1.741-1.104-1.648zm-53.007 44.74l-3.678 3.282-21.522 19.296-20.593-57.03-2.877-7.98 3.837-5.76 16.9-25.36 21.618 9.123 6.315 2.655 46.867 19.76-46.867 42.014z" />
    <path d="M111.133 39.907L87.874 5 58.126 17.556 51.81 20.21l-38.518 16.24-8.186 3.456L4 41.548l.63 1.74 7.703 6.905 42.115 37.733 3.678 3.3 27.333 24.5 26.152-72.437.63-1.74-1.108-1.642zM83.311 107.22L61.8 87.941l-3.674-3.297-46.881-42.018 46.88-19.76 6.297-2.659 21.623-9.118 16.903 25.36 3.833 5.758-2.877 7.99-20.593 57.022z" />
  </Icon>
);

export default LoginSvg;
